// components/ConfirmModal.jsx
import React, { useEffect } from "react";

export default function ConfirmModal({
  open,
  title,
  message,
  buttons = [],
  onClose,
  closeOnOverlay = true,
  // 옵션
  variant = "dialog",          // "dialog" | "toast"
  placement = "center",        // dialog: "center" | "top", toast: "bottom-right" | "bottom-left" | "top-right" | "top-left"
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const isToast = variant === "toast";

  // 위치 클래스 계산
  const wrapperClass = isToast
    ? (
      placement === "top-left" ? "fixed z-[1000] top-6 left-6" :
      placement === "top-right" ? "fixed z-[1000] top-6 right-6" :
      placement === "bottom-left" ? "fixed z-[1000] bottom-6 left-6" :
      "fixed z-[1000] bottom-6 right-6"
    )
    : (placement === "top"
      ? "fixed inset-0 z-[1000] flex items-start justify-center pt-24"
      : "fixed inset-0 z-[1000] flex items-center justify-center");

  // 카드 스타일
  const cardClass = isToast
    ? "relative w-[280px] rounded-xl bg-white shadow-[0_8px_30px_rgba(0,0,0,0.12)]"
    : "relative w-[420px] rounded-2xl bg-white shadow-[0_20px_80px_-24px_rgba(0,0,0,0.35)]";

  const titleClass = isToast ? "text-m font-semibold text-black/80" : "text-base font-semibold text-black/80";
  const bodyWrap = isToast ? "p-3" : "p-5";
  const msgWrap = isToast ? "mb-2" : "mb-5";
  const msgClass = isToast ? "text-[13px] text-neutral-700" : "text-sm text-neutral-700";
  const footerClass = isToast ? "flex justify-end gap-2 pt-1" : "flex justify-end gap-2";

  const closeBtnClass = isToast
    ? "absolute top-2 right-2 p-1 rounded-md hover:bg-black/5"
    : "absolute top-3 right-3 p-1.5 rounded-md hover:bg-black/5";

  return (
    <div className={wrapperClass}>
      {!isToast && (
        <div
          className="absolute inset-0 bg-black/40"
          onClick={closeOnOverlay ? onClose : undefined}
        />
      )}

      <div role="dialog" aria-modal="true" className={cardClass}>
        <div className={bodyWrap}>
          <div className="flex items-center justify-between mb-2">
            {title ? <h3 className={titleClass}>{title}</h3> : <div />}
            <button onClick={onClose} className={closeBtnClass} aria-label="닫기">✕</button>
          </div>

          {typeof message === "string"
            ? <p className={`${msgClass} ${msgWrap}`}>{message}</p>
            : <div className={msgWrap}>{message}</div>}

          <div className={footerClass}>
            {buttons.map((b, i) => {
              const base = "rounded-lg px-3 py-1.5 text-sm";
              const intent =
                b.intent === "primary"
                  ? "text-[#7864F9] bg-[#7864F9]/10 hover:bg-[#7864F9]/20"
                  : b.intent === "danger"
                  ? "text-rose-600 bg-rose-50 hover:bg-rose-100"
                  : "text-neutral-700 bg-neutral-200 hover:bg-neutral-300";
              return (
                <button
                  key={i}
                  autoFocus={b.autoFocus}
                  onClick={b.onClick}
                  className={`${base} ${intent}`}
                >
                  {b.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
